// angularApp/app/utils/global-functions.ts

// Implement the nameOf function
function nameOfImpl<T>(key: keyof T): string;
function nameOfImpl<T, Y>(key: keyof T, innerKey: keyof Y): string;
function nameOfImpl<T, Y>(key: keyof T, innerKey?: keyof Y): string {
    if (innerKey !== undefined) {
        return `${String(key)}.${String(innerKey)}`;
    }
    return String(key);
}

// Implement the ciFindByKey function
function ciFindByKeyImpl<T>(dict: Record<keyof T, any>, key: string): string {
    return Object.keys(dict)
        .filter((k) => k.toUpperCase() === key.toUpperCase())
        .map((k) => (dict as any)[k])
        .slice(-1)
        .pop();
}

// Make functions available globally
(globalThis as any).nameOf = nameOfImpl;
(globalThis as any).ciFindByKey = ciFindByKeyImpl;

// This makes the file a module (required for proper TypeScript compilation)
export {};
